import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const History = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.0833 24.1667L32.2917 29.375C32.6736 29.7569 32.8646 30.2431 32.8646 30.8333C32.8646 31.4236 32.6736 31.9097 32.2917 32.2917C31.9097 32.6736 31.4236 32.8646 30.8333 32.8646C30.2431 32.8646 29.7569 32.6736 29.375 32.2917L23.5417 26.4583C23.3333 26.25 23.1771 26.0156 23.0729 25.7552C22.9687 25.4948 22.9167 25.2257 22.9167 24.9479V16.6667C22.9167 16.0764 23.1163 15.5816 23.5156 15.1823C23.9149 14.783 24.4097 14.5833 25 14.5833C25.5903 14.5833 26.0851 14.783 26.4844 15.1823C26.8837 15.5816 27.0833 16.0764 27.0833 16.6667V24.1667ZM25 43.75C20.7986 43.75 17.0312 42.5087 13.6979 40.026C10.3646 37.5434 8.125 34.3056 6.97917 30.3125C6.80556 29.6875 6.86632 29.0972 7.16146 28.5417C7.4566 27.9861 7.91667 27.6389 8.54167 27.5C9.13194 27.3611 9.66146 27.4913 10.1302 27.8906C10.599 28.2899 10.9201 28.7847 11.0938 29.375C11.9965 32.4306 13.7413 34.8958 16.3281 36.7708C18.9149 38.6458 21.8056 39.5833 25 39.5833C29.0625 39.5833 32.5087 38.1684 35.3385 35.3385C38.1684 32.5087 39.5833 29.0625 39.5833 25C39.5833 20.9375 38.1684 17.4913 35.3385 14.6615C32.5087 11.8316 29.0625 10.4167 25 10.4167C22.6042 10.4167 20.3646 10.9722 18.2812 12.0833C16.1979 13.1944 14.4444 14.7222 13.0208 16.6667H16.6667C17.2569 16.6667 17.7517 16.8663 18.151 17.2656C18.5503 17.6649 18.75 18.1597 18.75 18.75C18.75 19.3403 18.5503 19.8351 18.151 20.2344C17.7517 20.6337 17.2569 20.8333 16.6667 20.8333H8.33333C7.74306 20.8333 7.24826 20.6337 6.84896 20.2344C6.44965 19.8351 6.25 19.3403 6.25 18.75V10.4167C6.25 9.82639 6.44965 9.3316 6.84896 8.93229C7.24826 8.53299 7.74306 8.33333 8.33333 8.33333C8.92361 8.33333 9.4184 8.53299 9.81771 8.93229C10.217 9.3316 10.4167 9.82639 10.4167 10.4167V13.2292C12.1875 11.0069 14.349 9.28819 16.901 8.07292C19.4531 6.85764 22.1528 6.25 25 6.25C27.6042 6.25 30.0434 6.74479 32.3177 7.73438C34.592 8.72396 36.5712 10.0608 38.2552 11.7448C39.9392 13.4288 41.276 15.408 42.2656 17.6823C43.2552 19.9566 43.75 22.3958 43.75 25C43.75 27.6042 43.2552 30.0434 42.2656 32.3177C41.276 34.592 39.9392 36.5712 38.2552 38.2552C36.5712 39.9392 34.592 41.276 32.3177 42.2656C30.0434 43.2552 27.6042 43.75 25 43.75Z"
        fill={color}
      />
    </svg>
  )
}
